<template>
  <div class="s4">
    <div class="container">
      <img src="@/assets/home/s4/title.png" class="title" alt="" />
      <div class="img-wrapper">
        <img src="@/assets/home/s4/image1.png" alt="" class="left-img" />
        <div class="center-img">
          <img :src="item" alt="" v-for="item in imgList" :key="item" />
        </div>
        <img src="@/assets/home/s4/image6.png" alt="" class="right-img" />
        <img src="@/assets/home/s4/logo.png" alt="" class="logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        require("@/assets/home/s4/image2.png"),
        require("@/assets/home/s4/image3.png"),
        require("@/assets/home/s4/image4.png"),
        require("@/assets/home/s4/image5.png"),
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.s4 {
  width: 100%;
  background: #ffffff;
  padding-top: 90px;
  // padding-bottom: 160px;
  box-sizing: border-box;
  margin: 0 auto;
  .container {
    // width: 1600px;
    margin: 0 auto;
    text-align: left;
    .title {
      width: 639.32px;
      height: 70px;
    }

    .img-wrapper {
      display: flex;
      position: relative;
      margin-top: 80px;

      .center-img {
        font-size: 0;
      }
      .logo {
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s4 {
      min-width: 1600px;
      height: 1030px;
    }
    .container {
      width: 1600px;
      height: 867px;

      .img-wrapper {
        width: 1600px;
        height: 630px;
        display: flex;
        position: relative;
        margin-top: 80px;
        .left-img {
          width: 424px;
          height: 630px;
        }

        .center-img {
          font-size: 0;
          img {
            width: 376px;
            height: 315px;
          }
        }
        .right-img {
          width: 424px;
          height: 630px;
        }
        .logo {
          width: 446px;
          height: 73.58px;
        }
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1616px) {
    .s4 {
      height: calc((100vw - 17px) * 0.64375);
    }
    .container {
      width: 90%;
      // height: calc(100% * 867px / 1600px);
      max-width: 1600px;
      .img-wrapper {
        @width: 100%;
        width: @width;
        .left-img {
          width: 26.5%;
          height: calc(@width * 0.39375);
        }

        .center-img {
          font-size: 0;
          img {
            width: 50%;
            height: 50%;
          }
        }
        .right-img {
          width: 26.5%;
          height: calc(@width * 0.39375);
        }

        .logo {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 27.875%;
          // height: 55 17px;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .s4 {
      height: 772.5px;
    }
    .container {
      width: 1083px;
      height: 650.25px;
      .img-wrapper {
        width: 1083px;
        height: 433px;
        .left-img {
          width: 26.5%;
          // height: calc(1083px * 0.39375);
        }

        .center-img {
          font-size: 0;
          img {
            width: 50%;
            height: 50%;
          }
        }
        .right-img {
          width: 26.5%;
        }
        .logo {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 334.5px;
          height: 55 17px;
        }

        // transform: scale(0.9);
      }
    }
  }
}
</style>
